import React from 'react';
import * as S from './styled';
import { useSelector } from 'react-redux';
import { selectDarkMode } from '../../core/store/app';

export const MainLogo = ({ isBig = false }: { isBig?: boolean }) => {
  const darkMode = useSelector(selectDarkMode);
  return (
    <S.LogoWrapper $isBig={isBig}>
      <S.Logo $darkMode={darkMode} />
    </S.LogoWrapper>
  );
};
